import { axios } from '@/utils/request'

const api = {
  model: '/enterprise/model',
  brand: '/enterprise/brand',
  management: '/enterprise/management',
  company: '/enterprise/management'
}

// 企业配置型号
export function configModel2 (parameter) {
  return axios({
    url: api.model + '/selectEnterpriseModelTree',
    method: 'get',
    params: parameter

  })
}


export function getSlectCombox (parameter) {
  return axios({
    url: api.company + '/selectCombox',
    method: 'get',
    params: parameter
  })
}

export function getModelList (parameter) {
  return axios({
    url: api.model + '/queryModel',
    method: 'get',
    params: parameter
  })
}
// 企业
export function getSelectTree (parameter) {
  return axios({
    url: api.management + '/selectTree',
    method: 'get',
    params: parameter
  })
}
// 型号
// export function getModelNumber (parameter) {
//   return axios({
//     url: api.model + '/selectModel',
//     method: 'get',
//     params: parameter
//   })
// }
// 品牌
export function getSelectBrand (parameter) {
  return axios({
    url: api.brand + '/selectBrand',
    method: 'get',
    params: parameter
  })
}

export function saveModel (parameter) {
  return axios({
    url: api.model + (parameter.modelId == 0 ? '/addModel' : '/editModel'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function delModel (parameter) {
  return axios({
    url: api.model + '/deleteModel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 禁用
export function forbiddenModel (parameter) {
  return axios({
    url: api.model + '/forbiddenModel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 启动
export function enableModel (parameter) {
  return axios({
    url: api.model + '/enableModel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 配置
export function relateModelEnterprise (parameter) {
  return axios({
    url: api.model + '/relateModelEnterprise',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 企业配置型号
export function configModel (parameter) {
  return axios({
    url: api.company + '/configModel',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 查询型号
export function selectAllModel (parameter) {
  return axios({
    url: api.model + '/selectAllModel',
    method: 'get',
    params: parameter
  })
}

// 查询企业关联型号
export function selectModelRelated (parameter) {
  return axios({
    url: api.model + '/selectModelRelated',
    method: 'get',
    params: parameter
  })
}
// 查询型号关联企业
export function selectModelEnterprise (parameter) {
  return axios({
    url: api.model + '/selectModelEnterprise',
    method: 'get',
    params: parameter
  })
}
//
export function exportModel (parameter) {
  return axios({
    url: api.model + '/exportModel',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  })
}
export function downloadErrorModel (parameter) {
  return axios({
    url: api.model + '/downloadErrorModel',
    method: 'post',
    data: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    }
  })
}

export const modelExport = api.model + '/export'
